import React, { Component } from 'react';
import { connect } from 'react-redux'

import Header from '../components/header'
import UsersList from '../components/users-list'
import ConsentsList from '../components/consents-list'


class DashboardComponent extends Component {
  renderLayout = () => {
    switch(this.props.layout.route) {
      case 'USERS_LIST':
        return <UsersList />
      case 'CONSENTS_LIST':
        return <ConsentsList />
      default:
        return <ConsentsList />
    }
  };

  render() {
    const layout = this.renderLayout()
    return this.props.user.role === 'admin' ? (
      <div className="dashboard">
        <Header />
        <div className="site-content">
          {layout}
        </div>
      </div>
    ): <div>You are not an administrator</div>
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    layout: state.layout
  }
}

const Dashboard = connect(
  mapStateToProps,
)(DashboardComponent);

export default Dashboard



// WEBPACK FOOTER //
// ./src/containers/dashboard.js